import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownBar() {
  // 3 hours in seconds
  const [timeLeft, setTimeLeft] = useState(10800);
  const [country, setCountry] = useState<string | null>(null);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (data && data.country_code) {
        setCountry(data.country_code);
      } else {
        setCountry('US');
      }
    }).catch(() => {
      setCountry('US');
    });
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const isAR = country === 'AR';
  return <div className="w-full bg-[#2D2D3F] text-white py-3 px-4 shadow-md relative z-20 border-b border-white/10" data-id="element-26" data-mp="13eacvu7v49cv">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center md:text-left" data-id="element-27" data-mp="18dn04g2nbifz">
        <div className="flex flex-col items-center md:items-start" data-id="element-28" data-mp="uex0otsct6og">
          <span className="text-[#FFD166] font-bold text-sm md:text-base uppercase tracking-wider flex items-center gap-2" data-id="element-29" data-mp="ye5v80v7x8l2">
            ⭐ Oferta especial por tiempo limitado
          </span>
          <span className="text-gray-300 text-xs md:text-sm mt-0.5" data-id="element-30" data-mp="1r44n040srjtf">
            Aprovechá el Mega Pack a {isAR ? '$29.990 ARS' : '$14.99 USD'} antes de que termine esta promoción
          </span>
        </div>

        <div className="flex items-center gap-2 bg-white/10 px-4 py-1.5 rounded-full mt-1 md:mt-0 border border-white/20 shadow-inner" data-id="element-31" data-mp="1hd0977muy506">
          <ClockIcon className="w-4 h-4 text-[#FFD166]" data-id="element-32" data-mp="25232xdurnob1" />
          <div className="font-mono font-bold text-lg tracking-wider text-white" data-id="element-33" data-mp="29ucmmc5afs4v">
            {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
          </div>
        </div>
      </div>
    </div>;
}